module.exports = __webpack_public_path__ + "img/header-engagementRingsPrincess@2x.a607866.webp";